import { ICustomizationImageEntity } from "../../../epics/customizations-epic";
import {
    CustomizationImageFilterDictionary,
    CustomizationImageStatus,
    ISettingsValue,
    ProductCustomizationSettingsMap,
} from "constants/product-customizations/customization";

export interface ICustomizationImagesPayload {
    images: (ICustomizationImageEntity | null)[];
    nextPageToken: string | null;
}

export interface ICustomizationModalState {
    currentAttributeId: string;
    currentMerchantId?: string;
    currentTabCacheKey: string;
    fetchParams: {
        merchantId: string;
        searchString: string;
    };
    isFetching: boolean;
    isChecking: boolean;
    existingImages: ICustomizationImagesPayload;
    imageFilters: CustomizationImageFilterDictionary | null;
    printSettings: ProductCustomizationSettingsMap;
}

export interface ICustomizationContextMethods {
    handleAttributeIdChange: (id: string) => void;
    handleTabChange: (tabType?: string) => void;
    getSearchString: () => string;
    saveSearchString: (searchString: string | null) => void;
    fetchImages: (
        merchantId: string | undefined,
        searchString: string | null,
        filters: CustomizationImageFilterDictionary | null,
        status?: CustomizationImageStatus | undefined
    ) => void;
    checkImages: (
        merchantId: string | undefined,
        searchString: string | null,
        filters: CustomizationImageFilterDictionary | null,
        ids: string[]
    ) => void;
    checkTab: (merchantId: string | undefined, ids: string[]) => void;
    resetImagesList: () => void;
    handleImageFiltersChange: (imageFilters: CustomizationImageFilterDictionary | null) => void;
    setPrintSettings: (settings: ISettingsValue[]) => void;
}

export type TCustomizationContextType = ICustomizationModalState & ICustomizationContextMethods;

export enum CustomizationModalActions {
    SetExistingImages = "SET_EXISTING_IMAGES",
    SetProductCustomizationPrintSettings = "SET_PRODUCT_CUSTOMIZATION_PRINT_SETTINGS",
    SetCurrentAttributeId = "SET_CURRENT_ATTRIBUTE_ID",
    SetMerchantId = "SET_MERCHANT_ID",
    SetImageFilters = "SET_IMAGE_FILTERS",
    ImagesFetchStart = "IMAGES_FETCH_START",
    ImagesFetchEnd = "IMAGES_FETCH_END",
    ImagesCheckStart = "IMAGES_CHECK_START",
    ImagesCheckEnd = "IMAGES_CHECK_END",
}
